module.exports = __webpack_public_path__ + "img/Event1.395b92af.jpeg";